module.exports = __webpack_public_path__ + "static/media/parallax-bg-20.886eed3b.jpg";